import { StructuredData } from './StructuredData';

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "AI Interview Software for Structured Hiring",
  "description": "Conduct consistent, asynchronous interviews and review candidates with structured insights — without replacing human judgment. Designed for hiring teams screening dozens to thousands of candidates per role.",
  "url": "https://beatview.ai/ai-interviews",
  "isPartOf": {
    "@type": "WebSite",
    "name": "Beatview",
    "url": "https://beatview.ai"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Beatview",
    "url": "https://beatview.ai"
  }
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://beatview.ai"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "AI Interviews",
      "item": "https://beatview.ai/ai-interviews"
    }
  ]
};

const softwareApplicationSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "Beatview AI Interview Software",
  "applicationCategory": "BusinessApplication",
  "operatingSystem": "Web",
  "url": "https://beatview.ai/ai-interviews",
  "description": "Asynchronous video interview platform with structured scoring for consistent candidate evaluation.",
  "featureList": [
    "Asynchronous video interviews",
    "Structured question sets",
    "AI-powered response scoring",
    "Answer-by-answer AI assessment",
    "Multi-device candidate access"
  ],
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "USD"
  },
  "creator": {
    "@type": "Organization",
    "name": "Beatview",
    "url": "https://beatview.ai"
  },
  "softwareHelp": {
    "@type": "WebPage",
    "url": "https://platform.beatview.ai/docs"
  }
};

export function AIInterviewsStructuredData() {
  return <StructuredData data={[webPageSchema, breadcrumbSchema, softwareApplicationSchema]} />;
}
